var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98001 3.86056C7.97508 3.85562 7.97005 3.85085 7.96492 3.84625L7.96493 10.1532C7.97005 10.1486 7.97508 10.1439 7.98001 10.1389L9.41307 8.70417C9.5107 8.60642 9.66899 8.60642 9.76662 8.70417C9.86425 8.80192 9.86425 8.96039 9.76662 9.05814L8.33356 10.4929C8.16765 10.659 7.9517 10.7445 7.73429 10.7493C7.7279 10.7498 7.72144 10.75 7.71493 10.75C7.70843 10.75 7.702 10.7498 7.69563 10.7493C7.47814 10.7445 7.26209 10.6591 7.09613 10.4929L5.66307 9.05814C5.56544 8.96039 5.56544 8.80192 5.66307 8.70417C5.7607 8.60642 5.91899 8.60642 6.01662 8.70417L7.44968 10.1389C7.45466 10.1439 7.45974 10.1487 7.46493 10.1534L7.46492 3.84611C7.45974 3.85076 7.45466 3.85557 7.44968 3.86056L6.01662 5.29531C5.91899 5.39305 5.7607 5.39305 5.66307 5.29531C5.56544 5.19756 5.56544 5.03908 5.66307 4.94134L7.09613 3.50658C7.43784 3.16447 7.99185 3.16447 8.33356 3.50658L9.76662 4.94134C9.86425 5.03908 9.86425 5.19756 9.76662 5.29531C9.66899 5.39305 9.5107 5.39305 9.41307 5.29531L7.98001 3.86056Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSortIcon);
export default __webpack_public_path__ + "static/media/DefaultSortIcon.57d7035118f9430729b39696744dc81d.svg";
export { ForwardRef as ReactComponent };